import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import usePost from "../product_list/usePost";
import usePut from "../product_list/usePut";
import { PRODUCTLIST } from "../../../routes/routes_name";

const defaultForm = {
  product_code: "",
  category_id: "",
  product_name: "",
  price: "",
  description: "",
  product_description: "",
  garment_description: "",
  color: "",
  fabric_id: "",
  fabric_type: "",
  fabric_product_description: "",
  season: "",
  shipping_info: "",
  measuring_description: "",
  status: "inaktif",
};

const UseFormProductList = ({ type }) => {
  const { handlePost, isLoading } = usePost();
  const { handlePut, isLoading: isLoadingPut } = usePut();

  const location = useLocation();
  const { id } = useParams();

  // 🔴 INIT LANGSUNG (INI KUNCI ADD AMAN)
  const [form, setForm] = useState(defaultForm);
  const [isOn, setIsOn] = useState(false);
  const [selectedThumbnail, setSelectedThumbnail] = useState(null);
  const [selectedAttachments, setSelectedAttachments] = useState([]);
  const [productImages, setProductImages] = useState([]); // File[]
  // const [attachments, setAttachments] = useState([]); // File[]
  const [attachments, setAttachments] = useState([]);
const [attachmentPreviews, setAttachmentPreviews] = useState([]);

// const [productImages, setProductImages] = useState([]);
// const [productImagePreviews, setProductImagePreviews] = useState([]);



  // ===============================
  // ✏️ INIT EDIT SAJA
  // ===============================
  useEffect(() => {
    if (type !== "put") return;
    if (!location.state) return;

    const data = location.state;

    setIsOn(data.status === "aktif");

    setForm({
      ...defaultForm,
      ...data, // overwrite hanya field yang ada
    });
  }, [type, location.state]);

  // ===============================
  // 🔁 SWITCH
  // ===============================
  const handleSwitch = () => {
    setIsOn(prev => !prev);
    setForm(prev => ({
      ...prev,
      status: !isOn ? "aktif" : "inaktif",
    }));
  };

  // ===============================
  // ✍️ INPUT
  // ===============================
  const handleChange = (e) => {
    const { id, value } = e.target;
    setForm(prev => ({ ...prev, [id]: value }));
  };

  // ===============================
  // 🖼 IMAGE
  // ===============================
  // const handleImageChange = (file, type) => {
  //   if (type === "thumbnail") {
  //     setSelectedThumbnail(file);
  //   } else {
  //     setSelectedAttachments(file.target.files);
  //   }
  // };

  // ===============================
  // 🚀 ADD (TIDAK DIUBAH LOGIKANYA)
  // ===============================
// ===============================
// 🚀 ADD (FINAL & AMAN)
// ===============================
const handleSubmit = async (eOrData) => {
  let payload;

  // ============================
  // 1️⃣ Dari <form onSubmit>
  // ============================
  if (eOrData?.preventDefault) {
    eOrData.preventDefault();

    payload = new FormData();

    Object.entries(form).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        payload.append(key, value);
      }
    });

    // 🔥 MULTI PRODUCT IMAGE
    productImages.forEach(file => {
      payload.append("product_image", file);
    });

    // 🔥 MULTI ATTACHMENTS
    attachments.forEach(file => {
  payload.append("attachments", file);
});

  }

  // ============================
  // 2️⃣ Dari handleFinalSubmit(payload)
  // ============================
  else if (eOrData instanceof FormData) {
    payload = eOrData;
  }

  // ============================
  // 3️⃣ Invalid
  // ============================
  else {
    throw new Error("Invalid submit parameter");
  }

  // ============================
  // 🚀 API CALL
  // ============================
  return handlePost({
    url: "/v1/product-list/create-product-list",
    form: payload,
    type: "multipart/form-data",
    navigation: PRODUCTLIST,
  });
};


  // ===============================
  // ✏️ EDIT
  // ===============================
const handleEdit = async (formData) => {
  if (!id) return;

  try {
    await handlePut({
      url: `/v1/product-list/${id}`,
      form: formData,
      type: "multipart/form-data",
      navigation: PRODUCTLIST,
    });
  } catch (err) {
    console.error("❌ EDIT PRODUCT ERROR:", err);
    throw err;
  }
};
  return {
    form,
    isOn,
    isLoading,
    isLoadingPut,
    handleChange,
    handleSwitch,
    // handleImageChange,
    handleSubmit, // ADD
    handleEdit,   // EDIT
  };
};

export default UseFormProductList;
